module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/hanna-shyriaieva-bkg-42c71ec93428e855a64f6871dd3ae72e.jpg";